/*
 * ALCHEMY Do Not Disturb PRE-LAUNCH page (template product.dnd-prelaunch only; loaded from a block in that template).
 * 1. Strips any subscription plan from the add-to-cart form (pre-orders are one-off only).
 * 2. Sticky "Pre-order now" bar (desktop and phone), shown only while the main button is off screen.
 * 3. "Read the pre-order terms" link opens and scrolls to the terms row.
 * 4. Sound on/off button on the ALWAYS ON film.
 */

/* 1. Seal still pre-selects a subscription plan in the form even when its widget is hidden. formdata fires on every
   FormData(form), so remove the plan from everything the form sends. */
(() => {
  const FORM = 'form[action$="/cart/add"]';
  const strip = () => document.querySelectorAll(FORM + ' [name="selling_plan"]').forEach((e) => { if (!e.disabled) e.disabled = true; });
  const hook = () => {
    document.querySelectorAll(FORM).forEach((f) => {
      if (f.dataset.dndGuard) return;
      f.dataset.dndGuard = '1';
      f.addEventListener('formdata', (e) => e.formData.delete('selling_plan'));
    });
    strip();
  };
  hook();
  let n = 0;
  const t = setInterval(() => { hook(); if (++n > 20) clearInterval(t); }, 500);
  document.addEventListener('submit', strip, true);
  document.addEventListener('click', strip, true);
})();

/* 2. Sticky pre-order bar. Buying always goes through the theme's real submit button (same cart, same properties). It is
   hidden while the sign-up form or the footer is on screen so it never covers the consent line. */
(() => {
  const SUBMIT = 'form[action$="/cart/add"] .product-form__submit[id^="ProductSubmitButton"]';

  function init() {
    if (document.querySelector('.dnd-sticky')) return;
    const btn = document.querySelector(SUBMIT);
    if (!btn || btn.disabled) return;
    const text = (sel) => ((document.querySelector(sel) || {}).textContent || '').replace(/\s+/g, ' ').trim();
    const now = text('.dnd-price__now');
    const was = text('.dnd-price__was');
    const title = text('.product__title, h1') || 'Do Not Disturb';
    const og = document.querySelector('meta[property="og:image"]');

    const bar = document.createElement('div');
    bar.className = 'dnd-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Pre-order Do Not Disturb');
    bar.innerHTML =
      '<div class="dnd-sticky__inner">' +
      (og ? '<img class="dnd-sticky__img" alt="" width="64" height="64">' : '') +
      '<div class="dnd-sticky__info"><p class="dnd-sticky__title"></p><p class="dnd-sticky__price"><span class="dnd-sticky__now"></span> <s class="dnd-sticky__was"></s> <span class="dnd-sticky__tag">Pre-order: 20% off</span></p></div>' +
      '<div class="dnd-sticky__action"><button type="button" class="dnd-sticky__button"></button><p class="dnd-sticky__note">Estimated dispatch December 2026.</p></div>' +
      '</div>';
    if (og) bar.querySelector('img').src = og.content;
    bar.querySelector('.dnd-sticky__title').textContent = title;
    bar.querySelector('.dnd-sticky__now').textContent = now;
    bar.querySelector('.dnd-sticky__was').textContent = was;
    bar.querySelector('button').textContent = 'Pre-order now' + (now ? ' · ' + now : '');
    bar.querySelector('button').addEventListener('click', () => btn.click());
    document.body.appendChild(bar);

    const hide = new Set();
    const update = () => bar.classList.toggle('is-visible', !hide.size);
    const watch = (el) => {
      if (!el) return;
      new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? hide.add(e.target) : hide.delete(e.target)));
        update();
      }).observe(el);
    };
    watch(btn);
    watch(document.querySelector('.dnd-signup'));
    watch(document.querySelector('.dnd-cta'));
    watch(document.querySelector('footer'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 3. Terms link: the terms live in a collapsible row, so open it and scroll to it. */
(() => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href="#dnd-preorder-terms"]');
    if (!a) return;
    const row = [...document.querySelectorAll('details.accordion__section')].find((d) => /PRE-ORDER TERMS/i.test(d.textContent.slice(0, 80)));
    if (!row) return;
    e.preventDefault();
    if (!row.open) row.querySelector('summary').click();
    setTimeout(() => row.scrollIntoView({ block: 'center' }), 50);
  });
})();

/* 4. ALWAYS ON film: a "Sound on / off" button on each copy of the video (desktop and phone copies exist; only the
   visible one shows its button). The video autoplays muted and loops; a tap turns sound on. */
(() => {
  const init = () => {
    document.querySelectorAll('.has-video video').forEach((v) => {
      if (v.dataset.dndSound) return;
      v.dataset.dndSound = '1';
      const host = v.parentElement;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'dnd-sound';
      const label = () => { b.textContent = v.muted ? 'Sound on' : 'Sound off'; b.setAttribute('aria-pressed', String(!v.muted)); };
      label();
      b.addEventListener('click', () => { v.muted = !v.muted; if (!v.muted) v.play().catch(() => {}); label(); });
      host.appendChild(b);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
})();
